"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _logo = _interopRequireDefault(require("./logo"));
var _util = require("../../../util");
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
var _constants = require("./constants");
var _currentStep = _interopRequireDefault(require("./current-step"));
var _completedStep = _interopRequireDefault(require("./completed-step"));
var _incompleteStep = _interopRequireDefault(require("./incomplete-step"));
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".pf-site-header {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  border-bottom: 1px solid #ececec;\n  display: flex;\n  padding: 15px 0 0 14px;\n  height: 55px;\n}\n@media (min-width: 768px) {\n  .pf-site-header {\n    padding-left: 32px;\n  }\n}\n.pf-site-header__logo {\n  margin-right: 6px;\n  width: 195px;\n}\n@media (min-width: 768px) {\n  .pf-site-header__logo {\n    padding-left: 0;\n  }\n}\n.pf-site-header__brand.pf-texts {\n  font-size: 8px;\n  -webkit-font-smoothing: antialiased;\n  color: #494949;\n  margin-top: 5px;\n  width: 30px;\n  line-height: normal;\n}\n@media (min-width: 768px) {\n  .pf-site-header__brand.pf-texts {\n    font-size: 13px;\n    line-height: 13px;\n    margin-top: 0;\n  }\n}\n.pf-site-header__statuses {\n  list-style-type: none;\n  display: flex;\n  margin-top: -4px;\n  margin-bottom: 10px;\n  margin-right: 10px;\n  padding-left: 0;\n  flex-grow: 1;\n  justify-content: right;\n}\n@media (min-width: 768px) {\n  .pf-site-header__statuses {\n    margin-right: 32px;\n  }\n}\n.pf-site-header__statuses li {\n  padding-top: 0;\n}\n@media (min-width: 1024px) {\n  .pf-site-header__statuses li {\n    padding-left: 3px;\n  }\n}\n.pf-site-header__statuses p {\n  display: none;\n}\n@media (min-width: 768px) {\n  .pf-site-header__statuses p {\n    display: block;\n    font-size: 13px;\n    font-weight: 700;\n    color: #4a6271;\n    float: right;\n    padding-top: 6px;\n  }\n}";
  var fileName = "header_styles_2c2290d7-4fad-44fa-ae1b-fa62ad9a7627";
  var element = document.querySelector("style[data-sass-component='header_styles_2c2290d7-4fad-44fa-ae1b-fa62ad9a7627']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-site-header';
var bem = (0, _util.klass)(BLOCK_CLASS);
var map = new Map([[_constants.ApplicationSteps.COMPLETED, function () {
  return /*#__PURE__*/_react.default.createElement(_completedStep.default, null);
}], [_constants.ApplicationSteps.CURRENT, function (step) {
  return /*#__PURE__*/_react.default.createElement(_currentStep.default, {
    step: step
  });
}], [_constants.ApplicationSteps.INCOMPLETE, function (step) {
  return /*#__PURE__*/_react.default.createElement(_incompleteStep.default, {
    step: step
  });
}]]);
var Header = function Header(_ref) {
  var logoHREF = _ref.logoHREF,
    brand = _ref.brand,
    statuses = _ref.statuses;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('logo')
  }, /*#__PURE__*/_react.default.createElement(_base.default, {
    as: "a",
    href: logoHREF
  }, /*#__PURE__*/_react.default.createElement(_logo.default, null))), /*#__PURE__*/_react.default.createElement(_base.default, {
    className: bem('brand')
  }, brand), statuses && /*#__PURE__*/_react.default.createElement("ul", {
    className: bem('statuses')
  }, statuses.map(function (status, idx) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: status.text
    }, map.has(status.icon) ? map.get(status.icon)(idx + 1) : null, /*#__PURE__*/_react.default.createElement(_base.default, null, status.text));
  })));
};
Header.propTypes = {
  logoHREF: _propTypes.default.string.isRequired,
  brand: _propTypes.default.string.isRequired,
  statuses: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    text: _propTypes.default.string
  }))
};
Header.defaultProps = {
  statuses: null
};
var _default = exports.default = Header;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-confirm-apply/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');